import { render, staticRenderFns } from "./DoughnutChart.component.vue?vue&type=template&id=72245d48&scoped=true&"
import script from "./DoughnutChart.component.vue?vue&type=script&lang=ts&"
export * from "./DoughnutChart.component.vue?vue&type=script&lang=ts&"
import style0 from "./DoughnutChart.component.vue?vue&type=style&index=0&id=72245d48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72245d48",
  null
  
)

export default component.exports